export default "__VITE_ASSET__D_WTXn2i__"